
<template>
   <v-layout>
      <v-flex sm10 xs12>
         </v-card>
            <v-card-text>
               <div class="title">{{ attribute.name }}</div>
               <bar-chart v-if="attribute.params.type === 'bar'" :data="graphData" :options="options" :height="120" :version="version"></bar-chart>
               <line-chart v-if="attribute.params.type === 'line'" :data="graphData" :options="options" :height="120" :version="version"></line-chart>
            </v-card-text>
         </v-card>
      </v-flex>

      <v-flex sm2 xs12>
         <v-radio-group v-model="period">
            <v-radio label="7 jours" value="7d"></v-radio>
            <v-radio label="30 jours" value="30d"></v-radio>
            <v-radio label="3 mois" value="3m"></v-radio>
         </v-radio-group>
         <v-btn fab small color="yellow" v-if="isAcquisitionManual" @click.native="addDialog = true">
            <v-icon dark>add</v-icon>
         </v-btn>
         <v-btn fab small dark color="red" :disabled="!this.clickedDatedValue" v-if="isAcquisitionManual" @click.native="removeMeasure()">
            <v-icon dark>remove</v-icon>
         </v-btn>
      </v-flex>

      <v-dialog v-model="addDialog" persistent max-width="400">
         <v-card>
            <v-card-title class="headline grey lighten-2">Ajouter une mesure</v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>

                        <v-flex xs12 sm6>
                           <v-menu
                              ref="menu"
                              lazy
                              :close-on-content-click="false"
                              v-model="menu"
                              transition="scale-transition"
                              offset-y
                              full-width
                              :nudge-right="40"
                              min-width="290px"
                           >
                              <v-text-field
                                 slot="activator"
                                 label="Date"
                                 :value="moment(measureDate).format('LL')"
                                 readonly
                              ></v-text-field>
                              <v-date-picker
                                 ref="picker"
                                 v-model="defaultDate"
                                 :max="moment().format()"
                                 locale="fr-FR"
                                 :first-day-of-week="1"
                                 scrollable
                              >
                                 <v-spacer></v-spacer>
                                 <v-btn flat color="primary" @click="menu = false">Annuler</v-btn>
                                 <v-btn flat color="primary" @click="measureDate = defaultDate; menu = false">OK</v-btn>
                              </v-date-picker>
                           </v-menu>
                        </v-flex>

                        <v-flex xs12>
                           <v-text-field
                              label="Valeur"
                              v-model="measureValue"
                              :error-messages="valueErrors"
                              @input="$v.measureValue.$touch()"
                              bbbblur="$v.measureValue.$touch()"
                           ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn :disabled="!formValid" color="brown darken-2" flat @click.native="addDialog = false; addMeasure()">Ajouter</v-btn>
               <v-btn color="brown darken-2" flat @click.native="addDialog = false">Annuler</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
      
   </v-layout>
</template>


<script>
   import LineChart from "@/components/users/LineChart.js"
   import BarChart from "@/components/users/BarChart.js"
   import moment from 'moment'
   import axios from 'axios'
   import config from '@/config'
   import { required, decimal } from 'vuelidate/lib/validators'

   const periodDescription = { '7d': { count: 7, step: 1}, '30d': { count: 10, step: 3}, '3m': { count: 10, step: 10} }

   export default {

      components: {
         LineChart,
         BarChart,
      },

      props: {
         userId: Number,
         attribute: Object,
      },

      data () {
         return {
            userAttributesDatedValues: null,
            options: {
               scales: {
                  xAxes: [{
                     type: 'time',
                     display: true,
                     distribution: 'linear',
                     bounds: 'data',
                     ticks: {
                        source: 'auto',
                     },
                     time: {
                        unit: 'day'
                     }
                  }]
               },
               onClick: this.onMeasureClick,
            },
            version: 0,
            graphData: null,
            period: '30d',

            addDialog: false,
            defaultDate: null,
            measureDate: new Date(),
            measureValue: null,
            menu: false,
            moment: moment,

            datedValues: null,
            clickedDatedValue: null,
         }
      },

      computed: {
         isAcquisitionManual () {
            return this.attribute.params.acquisition === 'manual'
         },
         isAcquisitionFitbit () {
            return this.attribute.params.acquisition === 'fitbit'
         },
         formValid () {
            if (this.$v.measureValue.$error) return false
            return true
         },
         valueErrors () {
            const errors = []
            if (!this.$v.measureValue.$dirty) return errors
            !this.$v.measureValue.required && errors.push("La valeur est obligatoire")
            !this.$v.measureValue.decimal && errors.push("Il faut saisir un nombre, par exemple : 69.5")
            return errors
         },
      },

      mounted () {
         this.getDataAndUpdateGraph()
      },

      methods: {
         getDataAndUpdateGraph: async function() {
            let self = this
            if (this.isAcquisitionManual) {
               let periodDescr = periodDescription[this.period]
               this.$store.dispatch('GET_USER_ATTRIBUTE_DATED_VALUES', {
                  userId: this.userId,
                  attributeId: this.attribute.id,
                  start: moment().add(-periodDescr.step * periodDescr.count, 'days').format("YYYY-MM-DDTHH:MM"),
                  end: moment().format("YYYY-MM-DDTHH:MM"),
               })
               .then(function(datedValues_) {
                  self.datedValues = datedValues_
                  let datetimeValues = datedValues_.map(datedValue => ({ dateTime: datedValue.date, value: datedValue.value }))
                  self.graphData = self.buildGraphData([datetimeValues])
                  // update graph view
                  self.updateGraph()
               })

            } else if (this.isAcquisitionFitbit) {
               let authorizationJWT = this.$store.state.authenticationData.token
               return axios({
                  method: 'get',
                  url: `${config.FITBIT_IS_AUTHORIZED_URL}?user=${this.userId}`,
                  headers: {"Authorization": `JWT ${authorizationJWT}`},
               })
               .then(function(response) {
                  let isAuthorized = response.data
                  if (isAuthorized) {
                     axios({
                        method: 'get',
                        url: `${config.FITBIT_ACCESS_TOKEN_URL}?user=${self.userId}`,
                        headers: {"Authorization": `JWT ${authorizationJWT}`},
                     })
                     .then(function(response) {
                        let accessToken = response.data
                        //console.log('accessToken', accessToken)
                        let promises = self.attribute.params.dimensions.map(function(dimension) {
                           return axios({
                              method: 'get',
                              url: `${config.FITBIT_USER_TIME_SERIES_URL}?access_token=${accessToken}&resource=${dimension.fitbit_resource}&period=${self.period}`,
                              headers: {"Authorization": `JWT ${authorizationJWT}`},
                           })
                        })
                        return Promise.all(promises)
                     })
                     .then(function(response) {
                        let valuesArray = response.map(e => e.data)
                        self.graphData = self.buildGraphData(valuesArray)
                     })
                     .then(function(response) {
                        self.updateGraph()
                     })
                  }
               })
               .catch(function(error) {
                  console.log('error', error)
               })
            }
         },

         buildGraphData: function(datedValuesArray) {
            let self = this
            let datasets = this.attribute.params.dimensions.map(function(dimension, index) {
               return {
                  label: dimension.name,
                  backgroundColor: dimension.color,
                  pointRadius: 5,
                  data: datedValuesArray[index].map(datedValue => ({ x: moment(datedValue.dateTime), y: parseFloat(datedValue.value) })),
               }
            })
            return {
               datasets: datasets,
               labels: [],
            }
         },

         updateGraph () {
            this.version += 1
         },

         onMeasureClick (event, chartElementArray) {
            console.log('onClick', chartElementArray)
            if (chartElementArray.length === 1) {
               if (chartElementArray.length !== 1) return
               let dataIndex = chartElementArray[0]._index
               this.clickedDatedValue = this.datedValues[dataIndex]
            } else {
               this.clickedDatedValue = null
            }
         },

         async removeMeasure () {
            await this.$store.dispatch('DELETE_USER_ATTRIBUTE_DATED_VALUE', this.clickedDatedValue)
            await this.getDataAndUpdateGraph()
            this.clickedDatedValue = null
         },

         addMeasure: async function() {
            let datedValue = {
               user: this.userId,
               author: this.$store.state.loggedUserId,
               attribute: this.attribute.id,
               date: moment(this.measureDate).format("YYYY-MM-DDTHH:MM"),
               value: this.measureValue,
            }
            await this.$store.dispatch('POST_USER_ATTRIBUTE_DATED_VALUE', datedValue)
            await this.getDataAndUpdateGraph()
            this.clickedDatedValue = null
         },
      },

      validations: {
         measureValue: { required, decimal },
      },

      watch: {
         period: function(newVal, oldVal) {
            // get data for the new period
            this.getDataAndUpdateGraph()
         }
      },
   }

</script>




// WEBPACK FOOTER //
// UserAttributeChart.vue?0e87349f